import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNews } from '../context/NewsContext';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiSend, FiZap, FiEdit3 } from 'react-icons/fi';

const Admin = () => {
  const { addArticle } = useNews();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    excerpt: '',
    content: 'Automated brief generated by the bureau engine.',
    category: 'SHORT_UPDATE',
    imageUrl: 'https://images.unsplash.com/photo-1508098662722-c9539cc35268?auto=format&fit=crop&w=1200&q=80',
    author: 'Bureau Desk'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    addArticle(formData);
    navigate('/news');
  };

  return (
    <div className="bg-[#050505] min-h-screen pt-40 pb-20 px-6 grid-pattern">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="max-w-2xl mx-auto">
        <div className="glass-card p-12 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-[#CCFF00]"></div>
          
          <div className="flex items-center gap-4 mb-12">
            <div className="w-12 h-12 bg-[#CCFF00] flex items-center justify-center text-black">
              <SafeIcon icon={FiEdit3} className="text-xl" />
            </div>
            <div>
              <h1 className="text-2xl font-black text-white tracking-tight uppercase">Manual Dispatch</h1>
              <p className="text-[#CCFF00] text-[10px] font-mono-data uppercase tracking-widest">Protocol Injection v1.0</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-8">
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">Headline (Max 60 chars)</label>
              <input 
                type="text" 
                required 
                placeholder="E.g.: OFFICIAL: MBAPPÉ SIGNS 5-YEAR DEAL" 
                value={formData.title} 
                onChange={(e) => setFormData({...formData, title: e.target.value})} 
                className="w-full bg-[#111] border border-white/5 p-6 text-white font-bold outline-none focus:border-[#CCFF00] transition-all"
              />
            </div>

            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">Dispatch Content</label>
              <textarea 
                required 
                rows="4" 
                placeholder="Enter the automated dispatch content here..." 
                value={formData.excerpt} 
                onChange={(e) => setFormData({...formData, excerpt: e.target.value})} 
                className="w-full bg-[#111] border border-white/5 p-6 text-slate-300 font-medium outline-none focus:border-[#CCFF00] transition-all"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">Classification</label>
                <select 
                  className="w-full bg-[#111] border border-white/5 p-4 text-xs font-bold uppercase tracking-widest text-white outline-none focus:border-[#CCFF00]" 
                  value={formData.category} 
                  onChange={(e) => setFormData({...formData, category: e.target.value})}
                >
                  <option value="SHORT_UPDATE">Flash Update</option>
                  <option value="TRANSFER_SNACK">Transfer Snack</option>
                  <option value="MATCH_NOTE">Match Report</option>
                </select>
              </div>
            </div>

            <button type="submit" className="w-full py-6 bg-[#CCFF00] text-black font-black text-[10px] uppercase tracking-[0.4em] hover:bg-white transition-all flex items-center justify-center gap-4 shadow-xl">
              <SafeIcon icon={FiSend} /> Inject into Feed
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default Admin;